import React, { useEffect, useState } from 'react';

const ImageSliderComponent = ({
    //type,
    //isOrigin,
    images,
    //setImages,
    //taetigkeitenImages,
    width,
    height,
    //setUpdatedImages,
    //setUpdatedIndex,
    //setIsChange
    setPreviewImage = () => {},
    setPreviewShown = () => {}
}) => {
    const [sliderImages, setSliderImages] = useState(images);
    const [currentSlide, setCurrentSlide] = useState(0);
    const totalSlides = images.length;

    useEffect(() => {
        setSliderImages(images);
        setCurrentSlide(0);
    }, [images]);

    useEffect(() => {}, [sliderImages]);

    const handleNextSlide = () => {
        if (sliderImages.length > 1) {
            setCurrentSlide((currentSlide + 1) % totalSlides);
        }
    };

    const handlePrevSlide = () => {
        if (sliderImages.length > 1) {
            setCurrentSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }
    };

    const sliderStyles = {
        position: 'relative',
        width,
        height,
        // marginRight:20,
    };

    const imgStyles = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        cursor: 'zoom-in'
    };

    const btnStyles = {
        position: 'absolute',
        top: '50%',
        backgroundColor: 'transparent',
        border: 'none',
        color: 'white',
        fontSize: '2rem',
        cursor: 'pointer'
    };

    const prevBtnStyles = {
        ...btnStyles,
        left: 0,
        transform: 'translateY(-50%)'
    };

    const nextBtnStyles = {
        ...btnStyles,
        right: 0,
        transform: 'translateY(-50%)'
    };

    return (
        <div className="slider" style={sliderStyles}>
            {sliderImages.length > 1 && (
                <button onClick={handlePrevSlide} style={prevBtnStyles}>
                    &lt;
                </button>
            )}
            {sliderImages.length > 0 && sliderImages[currentSlide] && (
                <img
                    onClick={() => {
                        setPreviewImage(images[currentSlide]);
                        setPreviewShown(true);
                    }}
                    src={images[currentSlide]}
                    alt={`Slide ${currentSlide + 1}`}
                    style={imgStyles}
                />
            )}
            {sliderImages.length === 0 && (
                <label className="handwai-text-label-normal">{'Keine Bilder vorhanden'}</label>
            )}
            {sliderImages.length > 1 && (
                <button onClick={handleNextSlide} style={nextBtnStyles}>
                    &gt;
                </button>
            )}

            {/*{isOrigin && sliderImages.length > 1 && (<div onClick={handleDeleteSlide} style={deleteBtnStyles}>*/}
            {/*    <span>-</span>*/}
            {/*</div>)}*/}
        </div>
    );
};

export default ImageSliderComponent;
